import React, { useEffect, useState } from 'react'
import constant from '../../constant';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';
import { v4_change_leave_application_staus, v4_leave_applications } from '../../actions/v4/leave';

const LeaveRequest = (props) => {

    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(1)
    const [limit, setLimit] = useState(5)
    const [refresh, setRefresh] = useState(false)


    useEffect(() => {
        v4_leave_applications(currentPage, limit).then((res) => {
            if (res.status) {
                setData(res.result);

            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, refresh])

    const changeApplicationStatus = (leaveId, status, remark = '') => {
        v4_change_leave_application_staus({ status, remark }, leaveId).then((res) => {
            if (res.status) {
                toast.success(res.result?.message || 'Status updated successfully');
                // Refresh data after status change
                setRefresh(!refresh)
            } else {
                toast.error(res.error || 'Failed to update status');
            }
        }).catch((err) => {
            toast.error('Error occurred while changing status');
        });
    };


    const [statusMap, setStatusMap] = useState({});
    const [reasonMap, setReasonMap] = useState({});

    const handleStatusChange = (id, newStatus) => {
        setStatusMap(prev => ({ ...prev, [id]: newStatus }));
    };

    const handleReasonChange = (id, newReason) => {
        setReasonMap(prev => ({ ...prev, [id]: newReason }));
    };

    const handleSubmit = (item) => {
        const newStatus = statusMap[item.ID];
        const reason = reasonMap[item.ID] || '';
        changeApplicationStatus(item.ID, newStatus, reason)
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title mb-4">Latest Leave Requests </h4>
                        <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th scope="col">User Information</th>
                                        <th scope="col">Leave Details</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data?.leaves?.length > 0 ? (
                                        data?.leaves.map((item, index) => (
                                            <React.Fragment key={item.ID}>
                                                <tr>
                                                    <td style={{ color: "#2b5a7e", fontSize: 15, fontFamily: "nunito" }}>
                                                        {index + 1}
                                                    </td>
                                                    <td>
                                                        <h5 className="font-size-14 mb-1">
                                                            <a href="#" className="text-dark">
                                                                {item.EMPLOYEE_NAME || item.FULL_NAME}
                                                            </a>
                                                        </h5>
                                                        <p className="text-muted mb-0">
                                                            {item.ROLE_NAME}{" "}
                                                            <span className="badge border border-light rounded-circle bg-success p-1" />
                                                        </p>
                                                        <p className="text-muted mb-0">
                                                            Site Location: <span style={{ color: "#ab5858" }}>{item.LOCATION_NAME}</span>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <p className="text-muted mb-0">
                                                            No. of Days Applied For:{" "}
                                                            <span style={{ color: "#e83e8c" }}>{item.TOTAL_DAYS} Days</span>
                                                        </p>
                                                        <p className="text-muted mb-0">
                                                            Dates on Leave:{" "}
                                                            <span style={{ color: "#e83e8c" }}>
                                                                {item.LEAVE_FROM} - {item.LEAVE_TO}
                                                            </span>
                                                        </p>
                                                        <p className="text-muted mb-0">
                                                            <i className="fa fa-sticky-note" style={{ fontSize: 16, color: "#50a5f1" }} />{" "}
                                                            {item.NOTE || 'No reason provided'}
                                                        </p>
                                                        <p className="text-muted mb-0">
                                                            <i className="fa fa-comment" style={{ fontSize: 16, color: "#50a5f1" }} />{" "}
                                                            {item.REMARKS || 'No remarks'}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <span style={{
                                                            color: item.STATUS === 'APPROVED' ? 'green' :
                                                                item.STATUS === 'REJECTED' ? 'red' :
                                                                    item.STATUS === 'PENDING' ? '#ffc107' :
                                                                        '#6c757d',
                                                            fontWeight: 500
                                                        }}>
                                                            {item.STATUS}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                                            <li className="list-inline-item px-2">
                                                                <button
                                                                    className={`btn btn-sm ${item.STATUS === 'PENDING' ? 'btn-warning' : 'btn-secondary'}`}
                                                                    title={item.STATUS === 'PENDING'
                                                                        ? 'View details and approve/reject the leave'
                                                                        : 'View leave details'}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target={`#leaveModal-${item.ID}`}
                                                                >
                                                                    {item.STATUS === 'PENDING' ? 'View & Approve/Reject' : 'View'}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                {/* Modal */}
                                                <div
                                                    className="modal fade"
                                                    id={`leaveModal-${item.ID}`}
                                                    data-bs-backdrop="static"
                                                    data-bs-keyboard="false"
                                                    tabIndex={-1}
                                                    role="dialog"
                                                    aria-labelledby="leaveModalLabel"
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="leaveModalLabel">
                                                                    Leave Application Details
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                />
                                                            </div>
                                                            <div className="modal-body">
                                                                <table className="table table-striped mb-3">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>Employee Name</td>
                                                                            <td>{item.EMPLOYEE_NAME || item.FULL_NAME}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Location</td>
                                                                            <td>{item.LOCATION_NAME}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Leave Duration</td>
                                                                            <td>{item.LEAVE_FROM} to {item.LEAVE_TO} ({item.TOTAL_DAYS} days)</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Reason</td>
                                                                            <td>{item.NOTE || 'No reason provided'}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Remarks</td>
                                                                            <td>{item.REMARKS || 'No remarks'}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td>Status</td>
                                                                            <td>
                                                                                <span style={{
                                                                                    color: item.STATUS === 'APPROVED' ? 'green' :
                                                                                        item.STATUS === 'REJECTED' ? 'red' :
                                                                                            item.STATUS === 'PENDING' ? '#ffc107' :
                                                                                                '#6c757d',
                                                                                    fontWeight: 500
                                                                                }}>
                                                                                    {item.STATUS}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>

                                                                {/* Action section */}
                                                                {item.STATUS === 'PENDING' && <><div className="mb-3">
                                                                    <label className="form-label">Change Status</label>
                                                                    <select
                                                                        className="form-select"
                                                                        value={statusMap[item.ID] || item.STATUS}
                                                                        onChange={(e) => handleStatusChange(item.ID, e.target.value)}
                                                                    >
                                                                        <option value="PENDING" disabled>Pending</option>
                                                                        <option value="APPROVED">Approve</option>
                                                                        <option value="REJECTED">Reject</option>
                                                                    </select>
                                                                </div>

                                                                    <div className="mb-3">
                                                                        <label className="form-label">Remarks (optional)</label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            rows="3"
                                                                            placeholder="Add a remark or note"
                                                                            value={reasonMap[item.ID] || ''} // <-- FIXED LINE
                                                                            onChange={(e) => handleReasonChange(item.ID, e.target.value)} // already correct
                                                                        />

                                                                    </div>
                                                                </>}
                                                            </div>
                                                            {item.STATUS === 'PENDING' && <div className="modal-footer">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-success"
                                                                    data-bs-dismiss="modal"
                                                                    onClick={() => handleSubmit(item)}
                                                                >
                                                                    Submit
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-light"
                                                                    data-bs-dismiss="modal"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>}
                                                        </div>
                                                    </div>
                                                </div>

                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center text-muted">No leave applications found</td>
                                        </tr>
                                    )}

                                </tbody>
                            </table>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <a
                                    href={constant.Authedcomponent.leaveApplications.url}
                                    type="button"
                                    className="btn btn-primary waves-effect btn-label waves-light"
                                    style={{
                                        backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)"
                                    }}
                                >
                                    <i className="bx bxs-right-arrow-square label-icon" /> View
                                    All Leave Requests
                                </a>
                            </div>
                        </div>
                        {/* end table-responsive */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(LeaveRequest)